// La mutuelle santé : ce qu'elle coûte chaque mois, et ce qu'elle laisse à payer sur les soins.
// Pendant les études, c'est une mutuelle étudiante qu'on peut refuser ; au travail, la mutuelle
// d'entreprise est obligatoire et l'employeur en paie au moins la moitié.
import type { GameState, MutuelleLevel } from '../engine/state';

/** Prix par mois des formules, au départ : mutuelle étudiante, puis part du salarié. */
export const MUTUELLE_PRICES: Record<'student' | 'employee', Record<MutuelleLevel, number>> = {
  student: { aucune: 0, base: 30, renforcee: 60 },
  employee: { aucune: 0, base: 60, renforcee: 110 },
};

/** Le prix d'une formule, au niveau des prix du moment. */
export function mutuellePrice(state: GameState, level: MutuelleLevel): number {
  const table = state.firstJobDay === null ? MUTUELLE_PRICES.student : MUTUELLE_PRICES.employee;
  return Math.round(table[level] * state.priceLevel);
}

/** Change de formule ; le prix du mois suit, sauf prix donné (la complémentaire santé solidaire, par exemple). */
export function setMutuelle(state: GameState, level: MutuelleLevel, monthly?: number): void {
  // Au travail, la mutuelle d'entreprise est obligatoire : pas de « sans mutuelle ».
  const chosen: MutuelleLevel = level === 'aucune' && state.firstJobDay !== null ? 'base' : level;
  state.mutuelleLevel = chosen;
  const amount = monthly ?? mutuellePrice(state, chosen);
  const expense = state.expenses.mutuelle;
  if (expense) expense.amount = amount;
  else state.expenses.mutuelle = { amount, examined: 0, optimized: false };
}

/** Les prix des soins sont doublés par rapport aux montants écrits dans les cartes… (choix de jeu) */
export const CARE_PRICE_FACTOR = 2;
/** …et chacun coûte 100 € de plus ; ce supplément suit l'inflation comme le reste. */
export const CARE_PRICE_SURCHARGE = 100;

/** Le reste à charge d'un soin selon la formule, au niveau des prix du moment. */
export function careCost(state: GameState, costs: Record<MutuelleLevel, number>): number {
  return Math.round((costs[state.mutuelleLevel] * CARE_PRICE_FACTOR + CARE_PRICE_SURCHARGE) * state.priceLevel);
}
